/**
 * GET un single type Strapi 4 : /api/{apiId}
 * REACT_APP_STRAPI_API_URL doit inclure /api (comme pour /postes).
 * @param {string} apiId ex. 'notre-histoire', 'nos-actions'
 * @param {{ populate?: string }} [options] ex. { populate: 'populate=*' } pour composants répétables
 * @returns {Promise<object|null>} attributes ou null
 */
export async function fetchStrapiSingleType(apiId, options = {}) {
  const base = process.env.REACT_APP_STRAPI_API_URL;
  if (!base) return null;

  const { populate } = options;
  const qs = populate ? (populate.startsWith('?') ? populate : `?${populate}`) : '';
  const url = `${base.replace(/\/$/, '')}/${apiId}${qs}`;
  const token = process.env.REACT_APP_STRAPI_API_TOKEN;

  const res = await fetch(url, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) return null;

  const json = await res.json();
  return json.data?.attributes ?? null;
}

